import React, { useEffect, useState } from "react";

import { fetchCmsBannerData } from "@/components/settings/api/networkUtils";

import BewareOfScammers from "../components/common/BewareOfScammers";
import { DownloadAppBanner } from "../components/common/DownloadAppBanner";
import { CmsBannerDataType, Payload } from "../types/setting";

const RightSideBanners = () => {
  const [cmsBannerData, setCmsBannerData] = useState<CmsBannerDataType>({
    Banner_1: [],
    Banner_2: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const previewValue = params.get("preview");

        let payload: Payload = {
          lob: "Seeker",
          page_category: "Settings_Page",
          filter_string: "[]",
        };

        if (previewValue === "true") {
          payload.preview = true;
        } else if (previewValue === "false") {
          payload.preview = false;
        }

        const bannerData = await fetchCmsBannerData(payload);
        setCmsBannerData(bannerData);
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <div className="setting-ads-container my-3 flex flex-col gap-5 md:w-[20%]">
      {cmsBannerData?.Banner_1 && (
        <BewareOfScammers data={cmsBannerData?.Banner_1} />
      )}
      {cmsBannerData?.Banner_2 && (
        <DownloadAppBanner data={cmsBannerData?.Banner_2} />
      )}
    </div>
  );
};

export default RightSideBanners;
